export default __webpack_public_path__ + "static/media/gallery-wip-pre-paint_02.1236fa76.jpg";